export class Entity {
  id: string;
  type: string;
  constructor(obj?: any) {

    if (!obj) {
      return;
    }

    this.id = obj.id;
    this.type = obj.type;
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/entity.model.ts